import { createContext } from 'react';

export const DeleteApiTokenModalContext = createContext({
  open: (tokenId: string) => {},
});
